import { SearchResults } from "./components"

export default SearchResults
